export const NFT_TRANSACTIONLOG_LIST_REQUEST = 'NFT_TRANSACTIONLOG_LIST_REQUEST';

export const NFT_TRANSACTIONLOG_LIST = 'NFT_TRANSACTIONLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_NFT_TRANSACTIONLOG_PAGINATION = 'SET_NFT_TRANSACTIONLOG_PAGINATION';

export const NFT_TRANSACTIONLOG_PAGE_RESET = 'NFT_TRANSACTIONLOG_PAGE_RESET';
